export { default as SideMenu } from 'secured/components/layout/SideMenu';
export { default as Navbar } from 'secured/components/layout/Navbar';



// WEBPACK FOOTER //
// src/modules/secured/components/layout/index.js